import { createSlice } from "@reduxjs/toolkit";

import { IProductStore } from "../types";

const initialState: IProductStore = {
  products: [],
};

export const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    setProducts: (state, { payload }) => {
      state.products = payload;
    },
  },
});

export const { setProducts } = productSlice.actions;
